// extracted by mini-css-extract-plugin
export default {"wrapperWaves":"waves_wrapperWaves__thaVT","waves":"waves_waves__w5tUA","parallax":"waves_parallax__iSVmt","move-forever":"waves_move-forever__PwTld"};